module.exports = __webpack_public_path__ + "img/avatar6.5014fc29.png";